import React from 'react';
import { ChevronDown, Info } from 'lucide-react';

/**
 * Einklappbare Hinweisbox. Zustand kommt von außen (persistiert in User-Settings).
 * tone: 'blue' | 'slate' | 'emerald'
 */
export default function CollapsibleHint({ id, title, collapsed, onToggle, tone = 'blue', icon: Icon = Info, children }) {
  const tones = {
    blue: 'bg-blue-50 border-blue-200 text-blue-900',
    slate: 'bg-slate-50 border-slate-200 text-slate-700',
    emerald: 'bg-emerald-50 border-emerald-200 text-emerald-900',
  };
  const iconTone = { blue: 'text-blue-600', slate: 'text-slate-500', emerald: 'text-emerald-600' }[tone];
  return (
    <div className={`rounded-xl border ${tones[tone]}`} data-testid={`hint-${id}`}>
      <button type="button" onClick={onToggle} aria-expanded={!collapsed} data-testid={`hint-${id}-toggle`}
        className="flex w-full items-center gap-3 px-4 py-3 text-left">
        <Icon className={`h-4 w-4 flex-shrink-0 ${iconTone}`} />
        <span className="flex-1 text-sm font-semibold">{title}</span>
        <ChevronDown className={`h-4 w-4 flex-shrink-0 opacity-60 transition-transform ${collapsed ? '' : 'rotate-180'}`} />
      </button>
      {!collapsed && <div className="px-4 pb-4 text-sm" data-testid={`hint-${id}-body`}>{children}</div>}
    </div>
  );
}
